// Lodge Config Selectors

export const getOffersEnabledLocation = state => {
  return state.isOffersEnabled;
};

export const getPointsMultiplier = state => {
  return state.loyaltyPointsMultiplier;
};

export const getReferralEnabledLocation = state => {
  return state.isLoyaltyReferralEnabled;
};

export const getDiningPackagesEnhancedUIActive = state => {
  return state.isDiningPackagesEnhancedUIEnabled;
};

export const getDynamicTileActive = state => {
  return state.isDynamicTileEnabled;
};

export const getHideOnlineCheckinText = state => {
  return state.hideOnlineCheckinText;
};

export const getStickyBottomBookingWidget = state => {
  return state.stickyBottomBookingWidget;
};

export const getPricePerWaterPass = state => {
  return state.pricePerWaterPass;
};

export const getFilters = state => {
  return JSON.parse(state.filters);
};

export const getAdditionalPersonAmount = state => {
  return state.additionalPersonAmount;
};

export const getIsHighestRatesEnabled = state => {
  return state.isHighestRatesEnabled;
};

export const getIsRateCalEnabled = state => {
  return state.isRateCalEnabled;
};

export const getUpdateSearchFullPageRefresh = state => {
  return state.updateSearchFullPageRefresh;
};

export const getFetchRestrictionsEnabled = state => {
  return state.isFetchRestrictionsEnabled;
};

export const getPerNightParkingFee1 = state => {
  return state.perNightParkingFee1;
};

export const getPerNightParkingFee2 = state => {
  return state.perNightParkingFee2;
};

export const getPerNightParkingFee3 = state => {
  return state.perNightParkingFee3;
};

export const getParkingFeeStartDate = state => {
  return state.parkingFeeStartDate;
};

export const getParkingFeeEndDate = state => {
  return state.parkingFeeEndDate;
};

export const getCreditCardAuthUrl = state => {
  return state.creditCardAuthUrl;
};

export const getAgeThreshold = state => {
  return state?.ageThreshold;
};

export const getIsLowestRatesRestrictionsEnabled = state => {
  return state.isLowestRatesRestrictionsEnabled;
};

export const getPaymentMethodsAllowed = state => {
  return {
    creditEnabled: state.creditEnabled,
    affirmEnabled: state.affirmEnabled,
    applePayEnabled: state.applePayEnabled,
    googlePayEnabled: state.googlePayEnabled,
    payPalEnabled: state.payPalEnabled,
    amexEnabled: state.amexEnabled
  };
};

export const getShouldLeadGenPop = state => {
  return state.shouldLeadGenPop;
};

export const getParkingCallout = state => {
  return state.parkingFeeCallout;
};

export const getParkingCalloutTitle = state => {
  return state.parkingFeeCalloutTitle;
};

export const getParkingCalloutDescription = state => {
  return state.parkingFeeCalloutDescription;
};

export const getBookingSummaryParkingFee = state => {
  return state.bookingSummaryParkingFee;
};

export const getUffTileEnabled = state => {
  return state.uffTileEnabled;
};

export const getIsLoyaltyPointsExpirationOnProfileEnabled = state => {
  return state.isLoyaltyPointsExpirationOnProfileEnabled;
};

export const getIsCartActive = state => {
  return state.isCartActive;
};
export const getIsI4IframeActive = state => {
  return state.isIFrameEnabled;
};

export const getIsRoomUnbundledRateWPAvailable = state => {
  return state.isRoomUnbundledRateWPAvailable;
};

export const getIsNewPatchEndpoint = state => {
  return state.newPatchEndpoint;
};

export const getMaxOccupancy = state => state.maxOccupancy;

export const getBeginReservationDate = state => state.beginReservationsDate;

export const getLoyaltyPointsToEarn = state => {
  return state.loyaltyPointsToEarn;
};

export const getLoyaltyEarnThresholdNights = state => {
  return state.loyaltyEarnThresholdNights;
};

export const getShowPackagesInAddGuestsModal = state => {
  return state.showPackagesInAddGuestsModal;
};

export const getIsManageYourReservationEnabled = state => {
  return state.isManageYourReservationEnabled;
};

export const getSuitePriceIncludedTaxesAndFees = state => {
  return state.suitePriceIncludedTaxesAndFees;
};

export const getTaxAndFeesLabels = state => {
  return state.taxAndFeeLabels ? JSON.parse(state.taxAndFeeLabels) : {};
};

export const getIsCancelReservationEnabled = state => {
  return state.isCancelReservationEnabled;
};

export const getIsAddGuestAPS = state => {
  return state.isAddGuestAPS;
};

export const getDaypassTicketLimit = state => {
  return state?.daypassTicketLimit;
};

export const getEnableMemberRates = state => {
  return state.enableMemberRates;
};

export const getIsAddGuestsEnabled = state => {
  return state.isAddGuestsEnabled;
};

export const getBirthdayPartyInclusionList = state => {
  return state.birthdayPartyInclusionList;
};

export const getIsBdayBookingWidgetActive = state => {
  return state.isBdayBookingWidgetActive;
};

export const getPartyKidsPerAdultRatio = state => {
  return state.partyKidsPerAdultRatio;
};
export const getPartyMaxGuestCount = state => {
  return state.partyMaxGuestCount;
};

export const getMinimumBookingDaysRestriction = state => {
  return state.minimumBookingDaysRestriction;
};
export const getMaximumBookingDaysRestriction = state => {
  return state.maximumBookingDaysRestriction;
};

export const getShowDiningPageInUFFFlow = state => {
  return state.showDiningPageInUFFFlow;
};

export const getShowResortFeeModal = state => {
  return state.showResortFeeModal;
};

export const getShowHighlightBadge = state => {
  return state.showHighlightBadge;
};

export const getIsSleepUpToCase = state => {
  return state.isSleepUpToCase;
};

export const getIdMeParameters = state => {
  return state.idMeParameters;
};

export const getIsHoldCancelReservationEnabled = state => state.isHoldCancelReservationEnabled;

export const getIsChangeDatesEnabled = state => state.isChangeDatesEnabled;

export const getMaxSpectatorsCount = state => state.maxSpectatorsCount;

export const getIsStaticDaypassEnabled = state => state.isStaticDaypassEnabled;

export const getShowAdventurePassesBeforeAttractionPassesInPreCheckInFlow = state =>
  state.showAdventurePassesBeforeAttractionPassesInPreCheckInFlow;

export const getSuiteCardVersionKEnabled = state => state.suiteCardVersionKEnabled;

export const getIsLoyaltyEnabled = state => state.isLoyaltyEnabled;

export const getIsInPrimerState = state => state.isInPrimerState;

export const getAffirmPubKey = state => state.affirmPubKey;

export const getIsTaxOnlyMessage = state => state.isTaxOnlyMessage;

export const getPromosForShortMessaging = state => state.promosForShortMessaging ?? [];

export const getLowestToHighestAttractionPasses = state => state.lowestToHighestAttractionPasses;

// THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
// TO BE DELETED ON RELEASE
export const getTempUffRedesignActive = state => state.tempUffRedesignActive ?? false;
// THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
// TO BE DELETED ON RELEASE

export const getPackMembersLimitFromState = state => {
  return state.packMembersLimit;
};

export const getHiddenOfferPrefixesFromState = state => {
  return state.hiddenOfferPrefixes;
};

export const getTaxesExcluded = state => state.taxesExcluded;

export const getFareFamilyV2only = state => state.fareFamilyV2only;
